import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import GCPSVG from '../../../assets/icons/clouds/gcp.svg?raw';

export const GCPLogo = (props) => <CustomSVG svg={GCPSVG} preserveColors {...props} />;
